import _ from 'lodash'

import template from '@stackhouse/dashboard-components/utils/template'
import { generatePath } from '@stackhouse/dashboard-components/Dashboard'

import Toast from '@stackhouse/dashboard-components/Toast'


export const makeCreate = ({ createPath, createInitialData }) => function create() {
    const editable = _.get(this.state, 'config.editable', {})
    const inlineAdd = editable === true || editable.add === true

    const { match: { params } } = this.props
    const initialData = createInitialData instanceof Function ? createInitialData(params) : createInitialData

    if (inlineAdd) {
        return this.gridRef.current.addRow(0, initialData)
    }
    else {
        return this.props.history.push({ pathname: generatePath(createPath, params), state: { onSave: this.loadData, data: initialData || {} } })
    }
}

export const makeDelete = ({ deleteEndpoint }) => function () {
    const { rows } = this.state
    const { client, withLoader } = this.props

    const selectedRow = this.getSelectedRow()

    if (selectedRow) {
        const { rowIndex, row } = selectedRow

        if (!row) {
            return this.gridRef.current.deleteRow(0, rowIndex)
        }

        return withLoader(done => {
            return client.delete(template(deleteEndpoint, row)).then(() => {
                this.selectedRow = null
                setTimeout(Toast.toast({ type: 'success', text: 'Deleted.' }), 3000)

                return this.setState({ rows: [...rows.slice(0, rowIndex), ...rows.slice(rowIndex + 1)] })
            }).then(done).catch(done)
        })
    }
}

const DefaultGridActions = ({ createPath, createInitialData, deleteEndpoint } = {}) => [
    {
        id: 'new',
        title: 'New',
        icon: 'add_circle',
        container: 'grid',
        onClick: makeCreate({ createPath, createInitialData }),
    },
    {
        id: 'delete',
        title: 'Delete',
        icon: 'delete_forever',
        container: 'grid',
        active: function () {
            return this.getSelectedRow()
        },
        onClick: makeDelete({ deleteEndpoint }),
    },
]


export default DefaultGridActions